import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  downloading: false,
  appLoading: false,
  globalSyncedInProgress: false,
  showDrawerFilter: false,
  drawerFilterActive: false,
  drawerFilterHeader: null,
  filterDrawerContent: null,
  filterDrawerSize: "378px",
  notifications: [],
  notificationOpen: false,
  notificationSeverity: "info",
  notificationMessage: "",
  drawerFilterStatus: {
    leadFilterActive: false,
    caseFilterActive: false,
    userFilterActive: false,
    activityFilterActive: false,
    unSyncedFilterActive: false,
    rolesFilterActive: false,
    companyFilterActive: false,
  },
  drawerFilterDates: {
    leadFilterDate: null,
    caseFilterDate: null,
    userFilterDate: null,
    activityFilterDate: null,
    unSyncedFilterDate: null,
    rolesFilterDate: null,
    companyFilterDate: null,
  },
};

const appSlice = createSlice({
  name: "app",
  initialState,
  reducers: {
    setLoading(state, action) {
      state.loading = action.payload;
    },
    setAppLoading(state, action) {
      state.appLoading = action.payload;
    },
    setDownloading(state, action) {
      state.downloading = action.payload;
    },
    setGlobalSyncedInProgress(state, action) {
      state.globalSyncedInProgress = action.payload;
    },
    setDrawerFilterActive(state, action) {
      const { boolIsLoading, scope } = action.payload;
      if (scope === "lead")
        state.drawerFilterStatus.leadFilterActive = boolIsLoading;
      else if (scope === "case")
        state.drawerFilterStatus.caseFilterActive = boolIsLoading;
      else if (scope === "users")
        state.drawerFilterStatus.userFilterActive = boolIsLoading;
      else if (scope === "unsyncedlead")
        state.drawerFilterStatus.unSyncedFilterActive = boolIsLoading;
      else if (scope === "activitylogs")
        state.drawerFilterStatus.activityFilterActive = boolIsLoading;
      else if (scope === "roles")
        state.drawerFilterStatus.rolesFilterActive = boolIsLoading;
      else if (scope === "company")
        state.drawerFilterStatus.companyFilterActive = boolIsLoading;
    },
    setFilterDates(state, action) {
      const { dates, scope } = action.payload;
      if (scope === "lead") state.drawerFilterDates.leadFilterDate = dates;
      else if (scope === "case") state.drawerFilterDates.caseFilterDate = dates;
      else if (scope === "users")
        state.drawerFilterDates.userFilterDate = dates;
      else if (scope === "unsyncedlead")
        state.drawerFilterDates.unSyncedFilterDate = dates;
      else if (scope === "activitylogs")
        state.drawerFilterDates.activityFilterDate = dates;
      else if (scope === "roles")
        state.drawerFilterDates.rolesFilterDate = dates;
      else if (scope === "company")
        state.drawerFilterDates.companyFilterDate = dates;
    },
    openDrawerFilter(state, action) {
      const { boolIsLoading, header, content, size } = action.payload;
      state.showDrawerFilter = boolIsLoading;
      state.drawerFilterHeader = header;
      if (
        (!state.filterDrawerContent && state.drawerFilterHeader) !==
        !state.drawerFilterHeader
      )
        state.filterDrawerContent = content;
      state.filterDrawerSize = size;
    },
    clearDrawerFilter(state, action) {
      state.filterDrawerContent = action.payload;
      state.filterDrawerSize = initialState.filterDrawerSize;
    },
    setNotification(state, action) {
      const { notificationMessage, notificationSeverity } = action.payload;

      state.notificationOpen = true;
      state.notificationSeverity = notificationSeverity;
      state.notificationMessage = notificationMessage;
    },
    setGlobalNotification(state, action) {
      const currentIndex = state.notifications.length;
      state.notifications = [{ ...action.payload, id: currentIndex }];
    },
    removeGlobalNotification(state, action) {
      var tempNotif = state.notifications;
      tempNotif.splice(action.payload, 1)
    },
    clearGlobalNotification(state, action) {
      state.notifications = [];
    },
    resetNotification(state, action) {
      state.notificationOpen = false;
      state.notificationSeverity = "info";
      state.notificationMessage = "";
    },
    logout: (state) => initialState,
  },
});

export const appActions = appSlice.actions;
export default appSlice;
